import { connect } from 'react-redux';
import { addPlayersToRoster, confirmRosterPlayers, editRosterPlayers, loadRosters, publishRoster, setRosterStatus } from '../../store/actions/rosters';
import { changePage, dismissError, isLoading } from '../../store/actions/app';
import { getRosters } from '../../util/reducer-helpers';
import Rosters from '../../components/Pages/Rosters';

const mapStateToProps = state => {

    // console.log( 'containers.Pages.Rosters.mapStateToProps', state );

    const rosters = getRosters( state );

    return {
        activeGame:       state.items.games.activeItem,
        context:          state.auth.context,
        error:            state.app.error,
        facecheckAway:    rosters.rosters && rosters.rosters.items && rosters.rosters.items.facecheckAway,
        facecheckHome:    rosters.rosters && rosters.rosters.items && rosters.rosters.items.facecheckHome,
        lastUpdate:       rosters.rosters && rosters.rosters.lastUpdate ? new Date( rosters.rosters.lastUpdate ) : null,
        loading:          state.app.loading,
        mergedAwayRoster: rosters.mergedAwayRoster,
        mergedHomeRoster: rosters.mergedHomeRoster,
        rosters:          rosters.rosters,
        simpleLineup:     rosters.rosters && rosters.rosters.items && rosters.rosters.items.simpleLineup,
        token:            state.auth.token,
        userSettings:     state.userSettings
    };

};

const mapDispatchToProps = dispatch => {

    return {
        onAddPlayersToRoster:   ( context, token, gameId, team, teamId, players, teamOfficials ) => dispatch( isLoading( true ) ) && dispatch( addPlayersToRoster( context, token, gameId, team, teamId, players, teamOfficials ) ),
        onChangePage:           route => dispatch( changePage( route ) ),
        onConfirmRosterPlayers: ( context, token, gameId, players ) => dispatch( isLoading( true ) ) && dispatch( confirmRosterPlayers( context, token, gameId, players ) ),
        onDismissError:         () => dispatch( dismissError() ),
        onEditRosterPlayers:    ( context, token, gameId, team, teamId, players ) => dispatch( isLoading( true ) ) && dispatch( editRosterPlayers( context, token, gameId, team, teamId, players ) ),
        onLoadRosters:          ( context, token, gameId ) => dispatch( isLoading( true ) ) && dispatch( loadRosters( context, token, gameId ) ),
        onPublishRoster:        ( context, token, gameId, team, teamId, publish ) => dispatch( isLoading( true ) ) && dispatch( publishRoster( context, token, gameId, team, teamId, publish ) ),
        onSetRosterStatus:      ( context, token, gameId, command ) => dispatch( isLoading( true ) ) && dispatch( setRosterStatus( context, token, gameId, command ) )
    };

};

export default connect( mapStateToProps, mapDispatchToProps )( Rosters );